export enum QuestionnaireName {
    caroBodyImageChange = 'caroBodyImageChange',
    caroBodyImageChange3Months = 'caroBodyImageChange3Months',
    caroEatingBehaviorChange = 'caroEatingBehaviorChange',
    caroEatingBehaviorChange3Months = 'caroEatingBehaviorChange3Months',
    caroPhysicalFunctionChange = 'caroPhysicalFunctionChange',
    caroPhysicalFunctionChange3Months = 'caroPhysicalFunctionChange3Months',
    caroPsychologicalFunctionChange = 'caroPsychologicalFunctionChange',
    caroPsychologicalFunctionChange3Months = 'caroPsychologicalFunctionChange3Months',
    caroSexualFunctionChange = 'caroSexualFunctionChange',
    caroSexualFunctionChange3Months = 'caroSexualFunctionChange3Months',
    caroSocialFunctionChange = 'caroSocialFunctionChange',
    caroSocialFunctionChange3Months = 'caroSocialFunctionChange3Months',
    evidencioRespiAller = 'evidencioRespiAller',
    obesiQBodyImage = 'obesiQBodyImage',
    obesiQEatingBehavior = 'obesiQEatingBehavior',
    obesiQPhysicalFunction = 'obesiQPhysicalFunction',
    obesiQPsychologicalFunction = 'obesiQPsychologicalFunction',
    obesiQSexualFunction = 'obesiQSexualFunction',
    obesiQSocialFunction = 'obesiQSocialFunction',
    osasEss = 'osasEss',
    osasHsdq = 'osasHsdq',
}
